import { Box, Grid, Skeleton } from "@mui/material";

const SkeletonSubjectLists = () => {
    return (
        <Grid size={12}>
            {/* Green line / parent heading */}
            <Box
                sx={{
                    backgroundColor: "#028A4F",
                    color: "white",
                    p: 1.5,
                    px: 3,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: "6px 6px 0 0",
                }}
            >
                {/* Left side: Program Title Skeleton */}
                <Skeleton variant="text" width={180} sx={{ bgcolor: "rgba(255,255,255,0.3)" }} />

                {/* Right side: Subjects | Videos Skeleton */}
                <Skeleton variant="text" width={120} sx={{ bgcolor: "rgba(255,255,255,0.3)" }} />
            </Box>

            {/* Accordion container with padding */}
            <Box
                sx={{
                    border: "1px solid #ddd",
                    borderTop: "none",
                    borderRadius: "0 0 6px 6px",
                    backgroundColor: "#fafafa",
                    px: 2,
                    py: 1.5,
                }}
            >
                {/* 🔹 Skeleton subjects list */}
                {Array.from({ length: 3 }).map((_, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 1,
                            borderBottom: "1px solid #eee",
                            gap: 1.5,
                        }}
                    >
                        <Skeleton variant="circular" width={24} height={24} />
                        <Box sx={{ flex: 1 }}>
                            <Skeleton width="60%" />
                            <Skeleton width="30%" />
                        </Box>
                    </Box>
                ))}
            </Box>
        </Grid>
    );
};

export default SkeletonSubjectLists;
